import type { FormElementComposerProps } from '@lemonade-hq/cdk';
import type { NumberShape, StringShape } from '@lemonade-hq/maschema-schema';
import type { AutocompleteProps, PredicateFactory } from '@lemonade-hq/uniclient-theme';
import type { UniclientAction } from '../../../action';
import type { FormSelectItemProps, FormSelectProps } from './formSelectComposer.types';
import type { BaseFormComponentProps, BaseFormComposerProps } from './types';

export const SEARCH_ATTRIBUTE = '__searchAttribute__';

export interface FormAutocompleteItemProps extends FormSelectItemProps {
  readonly aliases?: string[];
}

export type FormAutocompleteComposerConfigurableProps = BaseFormComponentProps &
  FormSelectProps &
  Omit<AutocompleteProps, 'additionalAction' | 'children' | 'notFound' | 'predicate' | 'value'> & {
    readonly items: FormAutocompleteItemProps[];
    readonly notFound?: {
      readonly label: string;
      readonly action?: UniclientAction;
    };
    readonly additionalAction?: {
      readonly label: string;
      readonly action: UniclientAction;
    };
    readonly answerTemplate?: Record<string, `{${string}}`> & {
      readonly value: '{value}';
    };
    readonly itemsUrl?:
      | string
      | {
          readonly url: string;
          readonly responseMap: {
            readonly data: string;
            readonly error: string;
          };
        };
    readonly predicate?: AutocompletePredicateType;
  };

type UniclientAutocompleteValueType =
  | AutocompleteProps['value']
  | (Record<string, unknown> & { readonly value: AutocompleteProps['value'] });

export type FormAutocompleteComposerProps = FormAutocompleteComposerConfigurableProps &
  FormElementComposerProps<UniclientAutocompleteValueType> & {
    readonly onExternalAction: (action: UniclientAction) => void;
    readonly shape?: NumberShape | StringShape;
    readonly failingAttributes?: BaseFormComposerProps['failingAttributes'];
  };

export type AutocompletePredicateType = keyof PredicateFactory;
